import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from '../common/shared.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class PermissaoGuard implements CanActivate {
  public shared: SharedService;

  constructor(private router: Router) {
    this.shared = SharedService.getInstance();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.shared.isLoggedIn()) {
      let permissao = this.shared.getPermissao(state.url.split("/")[1].concat("/").concat(route.routeConfig.path)); 
      if (!permissao || !permissao.inserir) {
        this.router.navigate(['/acesso-negado']);
        return false;
      }
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
